<template>
    <div class="wrapper">
            <div class="menuWrapper">
                <shopDataMenu 
                    @openShopData="openShopData"
                    @openShopSettings="openShopSettings"
                />
            </div>
        <div class="mainBody">
            <div class="singleTab" v-show="!isShopSettingsOpen">
                <shopData 
                    class="dataContainer"
                    ref="shopDataComp"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchShopData="patchShopData"
                />
                <juridicalData
                    class="dataContainer"
                    ref="juridicalDataComp"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchJuridicalData="patchJuridicalData"

                />
                <contactData
                    class="dataContainer"
                    ref="contactDataComp"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchShopData="patchShopData"
                />
            </div>

            <div class="singleTab" v-show="isShopSettingsOpen">
                <emailSettings
                    ref="emailSettingsComp"
                    class="dataContainer"
                    :emailAddress='emailAddress'
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                    @patchEmailSettings="patchEmailAddress"
                />
                <statusSettings
                    ref="statusSettingsComp"
                    class="dataContainer"
                    @patchStatusSettings="patchShopData"
                    :shopData='shopData'
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                />
                <notificationsSettings
                    ref="notificationSettingsComp"
                    class="dataContainer"
                    @patchNotificationSettings="patchDispatchInterval"
                    :channelsConf="channelsConf"
                    :activeEntity="activeEntity"
                    :patchError="patchError"
                    :patchSuccessful="patchSuccessful"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
import shopDataMenu from '@kristjan87/storium-workboard-library/src/components/main/shop/menu/menu.vue';

import contactData from '@kristjan87/storium-workboard-library/src/components/main/shop/data/contact.vue';
import juridicalData from '@kristjan87/storium-workboard-library/src/components/main/shop/data/juridical.vue';
import shopData from '@kristjan87/storium-workboard-library/src/components/main/shop/data/shop.vue';

import emailSettings from '@kristjan87/storium-workboard-library/src/components/main/shop/settings/email.vue';
import notificationsSettings from '@kristjan87/storium-workboard-library/src/components/main/shop/settings/notifications.vue';
import statusSettings from '@kristjan87/storium-workboard-library/src/components/main/shop/settings/status.vue';

// import core from '../api/index'
export default {
    name: 'shopSettingsView',
    components: {
        shopDataMenu,

        contactData,
        juridicalData,
        shopData,

        emailSettings,
        notificationsSettings,
        statusSettings
    },
    props: {
        idShop: null,
        shopData: null
    },
    watch: {
        shopData: {
            handler(newVal) {
                if (newVal) {
                    this.render = true
                    this.setShopData()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        },
        activeEntity: {
            handler() {
                this.patchError = null
            },
        }
    },
    data() {
        return {
            render: false,
            isShopSettingsOpen: false,

            channelsConf: null,
            newShopData: null,
            newPersonalData: null,

            emailAddress: null,

            activeEntity: null,
            patchError: null,
            patchSuccessful: null

        };
    },
    computed: {
      
    },
    methods: {
        openShopData() {
            this.isShopSettingsOpen = false
        },

        openShopSettings() {
            this.isShopSettingsOpen = true
        },

        processShopData(data) {
            this.newShopData = data
        },

        processPersonalData(data) {
            this.newPersonalData = data
        },

        setShopData: async function() {
            setTimeout(() => {
                this.$refs.shopDataComp.processData(this.shopData)
                this.$refs.contactDataComp.processData(this.shopData)
    
                this.getLegalEntity()
            }, 1)
            // this.$refs.juridicalDataComp.processData(res.data.shop)
                
        },

        getLegalEntity() {
            fetch(this.$fetchIp+`/v2/legal-entity/shop/`+this.idShop, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.data.legalEntity) {
                    this.$refs.juridicalDataComp.processData(res.data.legalEntity)
                }
            })
        },

        getDispatchInterval() {
            fetch(this.$fetchIp+'/v2/communication/user/conf', {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                },
                credentials: 'include',
            }) 
            .then((res) =>  res.json())
            .then((res) => {
                if(res.status == 'success') {
                    this.emailAddress = res.data.email
                    this.channelsConf = res.data.channelsConf
                    
                }
            })
        },

        patchDispatchInterval(payload, entity) {
            this.activeEntity = entity
            fetch(this.$fetchIp+'/v2/communication/user/conf', {
                method: 'PATCH',
                headers: {
                    'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                },
                credentials: 'include',
                body: payload
            }) 
            .then((res) =>  res.json())
            .then((res) => {
                if(res.status == 'success') {
                    this.$refs.shopDataComp.isEditingActive = false
                    this.$refs.juridicalDataComp.isEditingActive = false
                    this.$refs.contactDataComp.isEditingActive = false
                    
                    this.$refs.emailSettingsComp.isEditingActive = false
                    this.$refs.statusSettingsComp.isEditingActive = false
                    this.$refs.notificationSettingsComp.isEditingActive = false

                    this.patchError = null

                    this.patchSuccessful = true
                    setTimeout(() => {  
                        this.patchSuccessful = false
                    }, 1500)
                }
            })
        },

        patchShopData: async function(payload, entity) {  
            this.activeEntity = entity    
            fetch(this.$fetchIp+'/v2/shop/'+this.idShop, {
                method: 'PATCH',
                credentials: 'include',
                body: payload
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    // this.emailAddress = payload.changes.email
                    this.$refs.shopDataComp.isEditingActive = false
                    this.$refs.juridicalDataComp.isEditingActive = false
                    this.$refs.contactDataComp.isEditingActive = false

                    this.$refs.emailSettingsComp.isEditingActive = false
                    this.$refs.statusSettingsComp.isEditingActive = false
                    this.$refs.notificationSettingsComp.isEditingActive = false

                    this.patchError = null

                    this.patchSuccessful = true
                    setTimeout(() => {  
                        this.patchSuccessful = false
                    }, 1500)
                } else
                if(res.message == 'Shop must have a name provided upon registrating it.') {
                    this.patchError = 'Poel peab olema kuvanimi.'
                }
                if(res.message == 'Shop name cannot be less than 3 chars.') {
                    this.patchError = 'Poe kuvanimi ei saa olla vähem kui kolm tähte.'
                }
                if(res.message == 'Shop name cannot be longer than 30 characters.') {
                    this.patchError = 'Poe kuvanimi ei saa olla rohkem kui 30 tähte.'
                }
                if(res.message == 'Shop name contains forbidden letters.') {
                    this.patchError = 'Poe kuvanimi sisaldab keelatud sümboleid või tähemärkke.'
                }
                if(res.message == 'Shop name contains special forbidden characters.') {
                    this.patchError = 'Poe kuvanimi sisaldab keelatud sümboleid või tähemärkke.'
                }
                if(res.message == 'Shop page url must be atleast 3 chars long.') {
                    this.patchError = 'Poe URL peab olema vähemalt 3 tähemärki pikk.'
                }
                if(res.message == 'Shop page url must be less than 50 chars long.') {
                    this.patchError = 'Poe URL peab olema lühem kui 50 tähemärki.'
                }
                if(res.message == 'Slogan contains special forbidden characters.') {
                    this.patchError = 'Poe slogan sisaldab keelatud tähemärkke.'
                }
                if(res.message == 'Slogan contains forbidden letters.') {
                    this.patchError = 'Poe slogan sisaldab keelatud tähemärkke.'
                }
                if(res.message == 'Slogan out of length borders.') {
                    this.patchError = 'Poe slogan ei ole valiidse pikkusega(lubatud on 3-60 tähemärki).'
                }
                if(res.message == 'The chosen shop page url is already in use.') {
                    this.patchError = 'Valitud poe URL aadress on juba kasutusel.'
                }
                if(res.message == 'Provided cover image wasnt in an accepted image format.') {
                    this.patchError = 'Ühe või rohkema lisatud pildi formaat ei ole lubatud.'
                }
                if(res.message == "Description must not exceed 1200 chars.") {
                    this.patchError = `Kirjeldus on tohi ületada 1200 tähemärki(hetkel: ${res.data.curLength})`
                }
                if(res.message == "Description length must be atleast 15 characters.") {
                    this.patchError = 'Kirjeldus peab olema vähemalt 15 tähemärki'
                }
                if(res.message == "Something went wrong, please try again or contact support.") {
                    this.patchError = 'Midagi läks valesti, veenduge, et kõik lahtrid on täidetud ja proovige uuesti.'
                }
                if(res.message == "Attr must contain shopManager object.") {
                    this.patchError = 'Lisage poe haldaja informatsioon.'
                }
                if(res.message == "Shopmanager name must be of type string.") {
                    this.patchError = 'Lisage poe haldaja informatsioon.'
                }
                if(res.message == "Shopmanager cannot exceed 60 characters.") {
                    this.patchError = 'Poe haldaja nimi ei saa olla pikem kui 60 tähemärkkki.'
                }
                if(res.message == "Shopmanager name must be more than 4 characters.z") {
                    this.patchError = 'Poe haldaja nimi peab olema rohkem kui 4 tähemärki.'
                }
                if(res.message == "Shopmanager name contains forbidden characters.") {
                    this.patchError = 'Poe haldaja nimi sisaldab keelatud sümboleid või tähemärkke.'
                }
                if(res.message == "Shopmanager name contains special forbidden characters.") {
                    this.patchError = 'Poe haldaja nimi sisaldab keelatud sümboleid või tähemärkke.'
                }
                if(res.message == 'Invalid homepage url. The url must include either "http://" or "https://"') {
                    this.patchError = 'Poe kodulehe URL aadress peab algama kas "http://" või "https://"'
                }
                if(res.message == 'Not possible to open shop before activating it.') {
                    this.patchError = 'Enne poe avamist tuleb pood aktiveerida!'
                }
            })
        },

        async patchJuridicalData(payload, entity) {  
            this.activeEntity = entity    
            fetch(this.$fetchIp+'/v2/legal-entity/'+this.shopData.legalEntity.idLegalEntity, {
                method: 'PATCH',
                headers: {
                    'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            }) 
            .then((res) =>  res.json())
            .then((res) =>  {
                if(res.status == 'success') {
                    this.$refs.shopDataComp.isEditingActive = false
                    this.$refs.juridicalDataComp.isEditingActive = false
                    this.$refs.contactDataComp.isEditingActive = false

                    this.patchError = null

                    this.patchSuccessful = true
                    setTimeout(() => {  
                        this.patchSuccessful = false
                    }, 1500)
                } else
                if(res.message == "Register number must contain only numbers.") {
                    this.patchError = 'Registrikood peab sisaldama ainult numbreid.'
                }
                if(res.message == "Not possible to add any other than Estonian tax number.") {
                    this.patchError = 'Aktsepteeritud on ainult Eesti ehk EE algusega käibemaksu numbrid.'
                }
                if(res.message == "Tax number must contain only numbers after EE country code.") {
                    this.patchError = 'Peale EE algust peab käibemaksu number sisaldama ainult numbreid.'
                }
                if(res.message == "Tax number must be 11 chars long.") {
                    this.patchError = 'Käibemaksu number peab olema 11 numbrimärki pikk.'
                }
                if(res.message == "Missing an address element.") {
                    this.patchError = 'Sisestage enda tootmisaadress.'
                }
                if(res.message == "Phone number must be of type string.") {
                    this.patchError = 'Sisestage kontaktnumber.'
                }
                if(res.message == "Not a valid phone number.") {
                    this.patchError = 'Sisestatud kontaktnumber ei ole valiidne.'
                }
                if(res.message == "Name length must be between 3 and 64 characters.") {
                    this.patchError = 'Ettevõtte või esindaja nime pikkus ei ole valiidne(lubatud 3-64 tähemärki).'
                }
                if(res.message == "Cannot read property 'length' of null") {
                    this.patchError = 'Sisestage ettevõtte nimi.'
                }
                if(res.message == "Something went wrong, please try again or contact support.") {
                    this.patchError = 'Midagi läks valesti, veenduge, et kõik lahtrid on täidetud ja proovige uuesti.'
                }
            })
        },

        patchEmailAddress(payload, entity) {
            this.activeEntity = entity
            fetch(this.$fetchIp+'/v2/user/email', {
                method: 'PATCH',
                headers: {
                    'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            }) 
            .then((res) =>  res.json())
            .then((res => {
                this.errors = ''
                if(res.status == 'success') {
                    this.$refs.shopDataComp.isEditingActive = false
                    this.$refs.juridicalDataComp.isEditingActive = false
                    this.$refs.contactDataComp.isEditingActive = false
                    this.$refs.settingsComps.isEditingActive = false

                    this.patchError = null

                    this.patchSuccessful = true
                    setTimeout(() => {  
                        this.patchSuccessful = false
                    }, 1500)
                } else
                if(res.message == 'User must have a valid email.') {
                    this.patchError = 'Sisestage korrektne e-posti aadress(nt. sinuemail@gmail.com)'
                }
                if(res.message == 'Email change in process. Check emails for confirmation codes.') {
                    this.patchError = 'E-posti aadressi vahetamine pooleni, kinnituskood saadeti nii vanale kui ka uuele e-posti aadressile. Juhul kui sisestaise vale aadressi, saate uuesti proovida 4 tunni mõõdudes!'
                }
                if(res.message == 'Not possible to change email when user does not have a password.') {
                    this.patchError = 'Ilma kasutajale parooli seadistamata, saab Googlega registreeritud konto emaili saab vahetada ainult teise Google emaili vastu. Parooli on võimalik seadistada muutes parooli(praegune parool kinnitamiseks jätke tühjaks)'
                }
                if(res.message == 'User with the email provided already exists.') {
                    this.patchError = 'Sellise e-posti aadressiga kasutaja juba eksisteerib'
                }
            }))
        },
    },
    created() {
        this.getDispatchInterval()
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
}
.menuWrapper {
    display: fixed;
}
.mainBody {
    position: relative;
    width: 1420px;
    margin: 0 auto;
    padding-top: 150px;
}
.singleTab {
    display: flex;
    row-gap: 20px;
    column-gap: 20px;
}
.dataContainer {
    width: 33%;
}
@media (max-width: 1470px) {
    .mainBody {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
    }
}
@media (max-width: 1200px) {
    .singleTab {
        flex-wrap: wrap;
        column-gap: 1%;
    }
    .dataContainer {
        width: 49%;
    }
}
@media (max-width: 800px) {
    .singleTab {
        column-gap: 0;
    }
    .dataContainer {
        width: 100%;
    }
}
@media (max-width: 500px) {
    .menuWrapper {
        padding-top: 67px;
    }
}
@media (max-width: 420px) {
    .mainBody {
        width: 100%;
        padding-left:0px;
        padding-right:0px;
    }
}
</style>